<template>
  <ul
    class="menu vertical nested submenu is-drilldown-submenu first-sub vertical drilldown-submenu-cover-previous invisible"
    data-submenu
    role="group"
    aria-hidden="true"
  >
    <slot></slot>
  </ul>
</template>

<script>
export default {
  name: 'NavigationMobileItemSubmenu'
};
</script>
